<template>
  <v-row>
    <v-col cols="12" md="3">
      <v-img v-if="business.media.length !== 0" :src="business.media[0].media.url" max-width="100%" cover aspect-ratio="1"></v-img>
      <v-img v-else src="@/assets/placeholders/default-placeholder.jpeg" max-width="100%" cover aspect-ratio="1"></v-img>
    </v-col>
    <v-col cols="12" md="5">
      <h1 class="font-weight-thin">{{ business.alias }}</h1>
      <v-list dense>
        <v-list-item v-if="business.address !== null">
          <v-list-item-icon class="mr-2">
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ business.address.street_name }} {{ business.address.street_number }},
              {{ business.address.postcode }}
              {{ business.address.city }}
              ({{ business.address.district }})
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="business.email1 !== null">
          <v-list-item-icon class="mr-2">
            <v-icon>mdi-at</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <a :href="'mailto:' + business.email1">{{ business.email1 }}</a>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="business.phone1 !== null">
          <v-list-item-icon class="mr-2">
            <v-icon>mdi-phone</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <a :href="'tel:' + business.phone1">{{ business.phone1 }}</a>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="business.web_url !== null">
          <v-list-item-icon class="mr-2">
            <v-icon>mdi-web</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <a :href="business.web_url">{{ business.web_url }}</a>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col cols="12" md="4" v-if="business.description != null">
      <template v-if="!summary || business.description.length <= 683">
        <p>
          {{ business.description }}
          <v-btn text small color="primary" class="pa-0" v-if="!(business.description.length <= 683)" @click="summary=!summary">Leggi meno</v-btn>
        </p>
      </template>
      <template v-else>
        <p>
          {{ business.description.substring(0, 683) }}...
          <v-btn text small color="primary" class="pa-0" @click="summary=!summary">Leggi tutto</v-btn>
        </p>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import StoreComputed from '@/mixins/StoreComputed';

export default {
  name: 'BusinessRecap',
  mixins: [StoreComputed],
  data: () => ({
    getBusinessRequest: {loading: false},
    summary: true
  }),
  props: {
    business: Object,
  }
}
</script>

<style scoped>

</style>